/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_UnknownInputs */

const id_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Diketahui`)
};

const ms_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Diketahui`)
};

const da_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukendt`)
};

const de_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

const en_us2_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const es_es2_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconocido`)
};

const es_mx2_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconocido`)
};

const fil_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi Kilala`)
};

const fr_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inconnu`)
};

const it_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconosciuto`)
};

const hu_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismeretlen`)
};

const nl_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekend`)
};

const no_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukjent`)
};

const pl_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznane`)
};

const pt_br2_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const pt_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconhecido`)
};

const ro_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necunoscut`)
};

const fi_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntematon`)
};

const sv_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänd`)
};

const vi_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xác định`)
};

const tr_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen`)
};

const cs_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámé`)
};

const bg_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непознато`)
};

const ru_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестно`)
};

const uk_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невідомо`)
};

const ar_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير معروف`)
};

const hi_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात`)
};

const th_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ทราบ`)
};

const ja_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明`)
};

const zh_cn2_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const zh_hant1_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const ko_components_comparison_unknown = /** @type {(inputs: Components_Comparison_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Components_Comparison_UnknownInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_unknown = /** @type {((inputs?: Components_Comparison_UnknownInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_UnknownInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_unknown(inputs)
	if (locale === "ms") return ms_components_comparison_unknown(inputs)
	if (locale === "da") return da_components_comparison_unknown(inputs)
	if (locale === "de") return de_components_comparison_unknown(inputs)
	if (locale === "en-US") return en_us2_components_comparison_unknown(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_unknown(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_unknown(inputs)
	if (locale === "fil") return fil_components_comparison_unknown(inputs)
	if (locale === "fr") return fr_components_comparison_unknown(inputs)
	if (locale === "it") return it_components_comparison_unknown(inputs)
	if (locale === "hu") return hu_components_comparison_unknown(inputs)
	if (locale === "nl") return nl_components_comparison_unknown(inputs)
	if (locale === "no") return no_components_comparison_unknown(inputs)
	if (locale === "pl") return pl_components_comparison_unknown(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_unknown(inputs)
	if (locale === "pt") return pt_components_comparison_unknown(inputs)
	if (locale === "ro") return ro_components_comparison_unknown(inputs)
	if (locale === "fi") return fi_components_comparison_unknown(inputs)
	if (locale === "sv") return sv_components_comparison_unknown(inputs)
	if (locale === "vi") return vi_components_comparison_unknown(inputs)
	if (locale === "tr") return tr_components_comparison_unknown(inputs)
	if (locale === "cs") return cs_components_comparison_unknown(inputs)
	if (locale === "bg") return bg_components_comparison_unknown(inputs)
	if (locale === "ru") return ru_components_comparison_unknown(inputs)
	if (locale === "uk") return uk_components_comparison_unknown(inputs)
	if (locale === "ar") return ar_components_comparison_unknown(inputs)
	if (locale === "hi") return hi_components_comparison_unknown(inputs)
	if (locale === "th") return th_components_comparison_unknown(inputs)
	if (locale === "ja") return ja_components_comparison_unknown(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_unknown(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_unknown(inputs)
	return ko_components_comparison_unknown(inputs)
});
export { components_comparison_unknown as "components.comparison.unknown" }